(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18089,40659,81066,75847,44709,40852,81243,74453,44954,40617],{

/***/ 20597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_SpecialChallengesAndSolutions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./UI/components/ChallengesAndSolutions/index.jsx + 5 modules
var ChallengesAndSolutions = __webpack_require__(59870);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/BackgroundImages/utils/useBackgroundImages.js


var useBackgroundImages = function(param) {
    var data = param.data, type = param.type;
    var images = get_default()(data, "images");
    var imagesWithUrl = images === null || images === void 0 ? void 0 : images.map(function(image) {
        return (0,helper/* getFileUrl */.qm)(image);
    });
    return {
        type: type,
        imagesWithUrl: imagesWithUrl
    };
};

// EXTERNAL MODULE: ./UI/components/BackgroundImages/styles.module.scss
var styles_module = __webpack_require__(18828);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/BackgroundImages/index.jsx






var BackgroundImages = function(props) {
    var ref = useBackgroundImages(props), type = ref.type, imagesWithUrl = ref.imagesWithUrl;
    if (!imagesWithUrl) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((styles_module_default())[type]),
        children: imagesWithUrl.map(function(imageUrl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                src: imageUrl,
                alt: imageUrl
            });
        })
    });
};
BackgroundImages.defaultProps = {
    type: ""
};
BackgroundImages.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};
/* harmony default export */ var components_BackgroundImages = (BackgroundImages);

// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./UI/sections/SpecialChallengesAndSolutions/utils/challengesHelper.js



function checkBackgroundImageDisplaying(pageSlug) {
    return ![
        constants/* CASE_STUDIES.fernwayer */.qU.fernwayer
    ].includes(pageSlug);
}
var getBackgroundStyle = function(type, data) {
    switch(type){
        case constants/* CASE_STUDIES.fernwayer */.qU.fernwayer:
            var backgroundImageUrl = (0,helper/* getFileUrl */.qm)(get_default()(data, "images[0]", ""));
            return backgroundImageUrl ? {
                backgroundImage: "url(".concat(backgroundImageUrl, "), linear-gradient(180deg, #D45D94 0%, #FA717D 100%)")
            } : {};
        case constants/* CASE_STUDIES.openSense */.qU.openSense:
        case constants/* CASE_STUDIES.dindon */.qU.dindon:
        case constants/* CASE_STUDIES.driveFocus */.qU.driveFocus:
            var sectionBackgroundUrl = (0,helper/* getFileUrl */.qm)(get_default()(data, "background"));
            return sectionBackgroundUrl ? {
                backgroundImage: "url(".concat(sectionBackgroundUrl, ")")
            } : {};
        default:
            return {};
    }
};

;// CONCATENATED MODULE: ./UI/sections/SpecialChallengesAndSolutions/utils/useSpecialChallengesAndSolutions.js

var useSpecialChallengesAndSolutions = function(param) {
    var data = param.data, type = param.type;
    var title = data.title, subtitle = data.subtitle, description = data.description;
    var sectionBackgroundImage = getBackgroundStyle(type, data);
    var displayBackgroundImage = checkBackgroundImageDisplaying(type);
    return {
        data: data,
        type: type,
        title: title,
        subtitle: subtitle,
        description: description,
        sectionBackgroundImage: sectionBackgroundImage,
        displayBackgroundImage: displayBackgroundImage
    };
};

// EXTERNAL MODULE: ./UI/sections/SpecialChallengesAndSolutions/styles.module.scss
var SpecialChallengesAndSolutions_styles_module = __webpack_require__(93365);
var SpecialChallengesAndSolutions_styles_module_default = /*#__PURE__*/__webpack_require__.n(SpecialChallengesAndSolutions_styles_module);
;// CONCATENATED MODULE: ./UI/sections/SpecialChallengesAndSolutions/index.jsx








var SpecialChallengesAndSolutions = function(props) {
    var ref = useSpecialChallengesAndSolutions(props), data = ref.data, type = ref.type, title = ref.title, subtitle = ref.subtitle, description = ref.description, sectionBackgroundImage = ref.sectionBackgroundImage, displayBackgroundImage = ref.displayBackgroundImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()((SpecialChallengesAndSolutions_styles_module_default())[type], (SpecialChallengesAndSolutions_styles_module_default())[data.view], (SpecialChallengesAndSolutions_styles_module_default()).container),
        style: sectionBackgroundImage,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                subtitle: subtitle,
                description: description,
                type: type,
                titleStyle: (SpecialChallengesAndSolutions_styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChallengesAndSolutions/* default */.Z, {
                data: data,
                type: type,
                view: data.view,
                isSpecial: true
            }),
            displayBackgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BackgroundImages, {
                data: data,
                type: type
            })
        ]
    });
};
SpecialChallengesAndSolutions.defaultProps = {
    type: ""
};
SpecialChallengesAndSolutions.propTypes = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string
};
/* harmony default export */ var sections_SpecialChallengesAndSolutions = (SpecialChallengesAndSolutions);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 18828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"beautonomy":"styles_beautonomy__5mJjh","smartcenter":"styles_smartcenter__CnP2D"};

/***/ }),

/***/ 93365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1P3Js","image":"styles_image__ZrHSa","stickerbox":"styles_stickerbox__eNa4Z","firstSectionView":"styles_firstSectionView__SK6R7","fairy":"styles_fairy__S_YzU","seven-pm-thursday":"styles_seven-pm-thursday__RfX75","titleStyle":"styles_titleStyle__PXG1m","fernwayer":"styles_fernwayer__F2UqS","hotel-data-cloud":"styles_hotel-data-cloud__uao1C","open-sense":"styles_open-sense__HlQwJ","famlicious":"styles_famlicious___EDVg","secondSectionView":"styles_secondSectionView__PJwtw","drive-focus":"styles_drive-focus__wEQmG","contentContainer":"styles_contentContainer__m2x8q","thirdSectionView":"styles_thirdSectionView__FSnkX","fourthSectionView":"styles_fourthSectionView__Izsiv","travel-trivia":"styles_travel-trivia__RRbUp","tell":"styles_tell__RCfcZ","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__dENqh","fusion-markets":"styles_fusion-markets__N6TzP","beautonomy":"styles_beautonomy__Tvrne","meateater":"styles_meateater__4WViw","telemojo":"styles_telemojo__Nd1vc","blackbird":"styles_blackbird__Tyn_J","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__ayrwU","smartcenter":"styles_smartcenter__vxX62","dindon":"styles_dindon__YgIzK","humankind":"styles_humankind__39iCs","cinnabar":"styles_cinnabar__z7i4s","mobile-bank-application":"styles_mobile-bank-application__qHpcj"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);